import { createSlice, Draft, PayloadAction } from '@reduxjs/toolkit'

interface LayoutState {
  sideBarCollapsed: boolean
  moduleSelectorCurrentPageId: number
}

const initialState: LayoutState = {
  sideBarCollapsed: false,
  moduleSelectorCurrentPageId: 0,
}

export const LayoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    setSideBarCollapsed: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.sideBarCollapsed>
    ) => {
      state.sideBarCollapsed = action.payload
    },
    setModuleSelectorCurrentPageId: (
      state: Draft<typeof initialState>,
      action: PayloadAction<typeof initialState.moduleSelectorCurrentPageId>
    ) => {
      state.moduleSelectorCurrentPageId = action.payload
    },
    resetLayoutSlice: () => initialState,
  },
})

export const getLayoutState = (state: { layout: LayoutState }) => state.layout
export const {
  setSideBarCollapsed,
  setModuleSelectorCurrentPageId,
  resetLayoutSlice,
} = LayoutSlice.actions
export default LayoutSlice.reducer
